
import { createClient } from '@supabase/supabase-js';

// La base de datos ahora vive en AWS RDS y se accede a través del gateway
// compatible con Supabase en /api/sb (api/_sb). La URL puede ser relativa
// ("/api/sb"): se resuelve contra el dominio desde el que se sirve la app.
const rawSupabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string | undefined;

if (!rawSupabaseUrl || !supabaseAnonKey) {
  const missing: string[] = [];
  if (!rawSupabaseUrl) missing.push('VITE_PUBLIC_SUPABASE_URL');
  if (!supabaseAnonKey) missing.push('VITE_PUBLIC_SUPABASE_ANON_KEY');
  throw new Error(`Missing Supabase environment variables: ${missing.join(', ')}`);
}

export const supabaseUrl = /^https?:\/\//i.test(rawSupabaseUrl)
  ? rawSupabaseUrl.replace(/\/+$/, '')
  : new URL(rawSupabaseUrl, window.location.origin).href.replace(/\/+$/, '');
export { supabaseAnonKey };

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

export type Database = {
  public: {
    Tables: {
      users: {
        Row: {
          id: string;
          email: string;
          first_name: string;
          last_name: string;
          company_name: string;
          phone: string | null;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id: string;
          email: string;
          first_name: string;
          last_name: string;
          company_name: string;
          phone?: string | null;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          email?: string;
          first_name?: string;
          last_name?: string;
          company_name?: string;
          phone?: string | null;
          created_at?: string;
          updated_at?: string;
        };
      };
    };
  };
};
